import React from 'react';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Services } from '../components/Services';
import { PopularRoutes } from '../components/PopularRoutes';
import { QuoteForm } from '../components/QuoteForm';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Fleet } from '../components/Fleet';
import { Reviews } from '../components/Reviews';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <main className="flex-grow" data-id="element-336">
      <Hero data-id="element-337" />
      <TrustBar data-id="element-338" />
      <Services data-id="element-339" />
      <PopularRoutes data-id="element-340" />
      <QuoteForm data-id="element-341" />
      <WhyChooseUs data-id="element-342" />
      <Fleet data-id="element-343" />
      <Reviews data-id="element-344" />
      <FAQ data-id="element-345" />
      <FinalCTA data-id="element-346" />
    </main>;
}